export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',
  NOTIFICATIONS: '/notifications',
  WITHDRAWALS: '/withdrawals',
  MOCKED_TEACHERS: '/mocked-teachers',
  LIVE_TEACHERS: '/live-teachers',
  TUTOR_LEADS: '/tutor-leads',
  MARKETING: '/marketing',
  VERIFICATIONS: '/verifications',
};
